import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { accept_vendor_agreement, fetch_vendor_agreements } from './api';

export const VENDOR_AGREEMENTS_KEY = ['vendor-agreements'] as const;

/** Current agreement version for each of the vendor's modules + how many are unaccepted. */
export function use_vendor_agreements() {
  return useQuery({ queryKey: VENDOR_AGREEMENTS_KEY, queryFn: fetch_vendor_agreements });
}

export function use_accept_agreement() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (agreement_id: string) => accept_vendor_agreement(agreement_id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: VENDOR_AGREEMENTS_KEY });
      qc.invalidateQueries({ queryKey: ['onboarding', 'agreement'] });
    },
  });
}
